import CommentVM from './comment-vm';
import Thread from './thread';
import Modal from 'libs/components/modal';

export default function(data) {
  var self                  = this;
  self.forum_id             = ko.observable();
  self.id                   = ko.observable();
  self.title                = ko.observable('');
  self.content              = ko.observable('');
  self.voted                = ko.observable(false);
  self.subscribed           = ko.observable('');
  self.vote_count           = ko.observable(0);
  self.deleted              = ko.observable(0);
  self.thread_comments      = ko.observableArray([]);
  self.comment_count        = ko.observable(0);
  self.nested_comment_index = 0;
  self.selected_filter      = ko.observable();

  self.filter_options = [
    { label: 'Newest', filter: 0, callback: 'sort_by_date', params: 'asc' },
    { label: 'Oldest', filter: 1, callback: 'sort_by_date', params: 'desc' },
    { label: 'Most Votes', filter: 2, callback: 'sort_by_votes', params: 'asc' },
    { label: 'Least Votes', filter: 3, callback: 'sort_by_votes', params: 'desc' }
  ];

  self.vote_count_formatted = ko.computed(function() {
    return self.vote_count();
  }, self);

  self.user = ko.observable('');

  self.mappingOptions = {
    thread_comments: {
      create: function(options) {
        return new CommentVM(options.data, self.id(), 'ForumThread');
      }
    }
  };

  self.thread_comments.subscribe(function(newValue) {
    self.comment_count(0);
    self.count_nested_comments(newValue);
    Prism.highlightAll();
  });

  self.selected_filter.subscribe(function(index) {
    // Can't filter unless an index is provided
    if(!index && index !== 0) {
      return;
    }

    var filter = self.filter_options[index],
      params = filter.params.split(',');

    self[filter.callback].apply(self, params);
  });

  self.count_nested_comments = function(comments) {
    _.each(comments, function(comment) {

      if(comment.parent_type() === 'ForumThread') {
        self.nested_comment_index = 0;
      }

      comment.nested_index(self.nested_comment_index);

      self.nested_comment_index += 1;
      self.comment_count(self.comment_count() + 1);

      if(comment.thread_comments().length) {
        self.count_nested_comments(comment.thread_comments());
      } else {
        self.nested_comment_index = 1;
      }
    });
  };

  self.filter_label = ko.computed(function() {
    return 'Sort ' + self.comment_count() + ' Comments By:';
  });

  // Filter on thread_comments array by created_at
  self.sort_by_date = function(direction) {
    var sorted = self.recursive_sort(self.thread_comments(), direction, 'date');
    self.thread_comments(sorted);
  };

  // Filter on thread_comments array by vote_count
  self.sort_by_votes = function(direction) {
    var sorted = self.recursive_sort(self.thread_comments(), direction, 'votes');
    self.thread_comments(sorted);
  };

  self.recursive_sort = function(comments, direction, type) {
    _.each(comments, function(com) {
      if(com.thread_comments().length > 0) {
        var sorted = self.sort_by_type(com.thread_comments(), direction, type);
        com.thread_comments(sorted);
        self.recursive_sort(com.thread_comments(), direction, type);
      }
    });

    return self.sort_by_type(comments, direction, type);
  };

  self.sort_by_type = function(comments, direction, type) {
    if (type == 'date'){
      return _.sortBy(comments, function(com) {
        var dt = new Date(com.created_at());
        if(direction == 'asc') {
          return -dt;
        } else if(direction == 'desc') {
          return dt;
        }
      });
    }
    else if (type == 'votes') {
      return _.sortBy(comments, function(com) {
        if(direction == 'asc') {
          return -com.vote_count();
        } else if(direction == 'desc') {
          return com.vote_count();
        }
      });
    }
  };

  self.get_permalink = function(_self) {
    let path = Kadenze.Routes.course_forum_thread_path(
      $('#course_id').val(), _self.forum_id(), _self.id()
    )

    if (typeof _self.forum_thread_id === 'function')
      path = Kadenze.Routes.course_forum_thread_path(
        $('#course_id').val(),
        _self.forum_id(),
        _self.forum_thread_id(),
        { comment_id: _self.id() }
      )

    const url = window.location.origin + path

    Modal.for('permalink', {
      title: 'Permalink',
      body: url,
      cancelBtnText: 'Close',
      copyText: 'Copy'
    })

    $('#js-to-copy').select()
  }

  self.add_new_comment = function(comment) {
    var thread_comment_form = _.find(self.thread_comments(), function(thread_comment){ return thread_comment.id() == null;});
    if(typeof thread_comment_form === 'undefined'){
      // console.log('adding comment...');
      var comment_data = {
        forum_id: self.forum_id(),
        forum_thread_id: self.id(),
        depth: 0
      };
      self.thread_comments.unshift(new CommentVM(comment_data, self.id(), 'ForumThread'));
      Thread.scrollToElement(document.getElementById('comment_null'));
      Kadenze.IframeUtils.decorateAll();
    }
  };

  self.delete_comment = function() {
    var course_id = $('#course_id').val();
    if (typeof self.thread_comments === 'function' && self.thread_comments().length > 0 && (self.thread_comments()[0].deleted() != true && self.thread_comments().length == 1)  ) {
      Kadenze.UIUtil.confirmAction('This thread has replies, so you cannot remove it. Continuing will simply remove the description for the thread but the comments will remain. Are you sure you wish to continue?',
        function() {
          self.content('<em>This description was removed</em>');
          self.deleted(true);

          var request = new Kadenze.AjaxRequest({
            type: 'PATCH',
            url: Kadenze.Routes.course_forum_thread_path(course_id, self.forum_id(), self.id()),
            data: {
              'forum_thread': {
                content: self.content()
              }
            }
          });

          request.done(function() {
            window.location.reload(true)
            new Kadenze.Notice.success({ message: 'Thread description removed' });
          });

          request.fail(function(data) {
            new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });

            console.log('Delete failed');
            console.log(data.responseText);
          });
        }
      );
    } else {
      Kadenze.UIUtil.confirmAction('Are you sure you want to delete this thread?',
        function() {
          var request = new Kadenze.AjaxRequest({
            type: 'DELETE',
            url: Kadenze.Routes.course_forum_thread_path(course_id, self.forum_id(), self.id()),
            data: { '_method' : 'delete' }
          });

          request.done(function(data) {
            window.location.replace(data.url);
          });

          request.fail(function(data) {
            new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });

            console.log('Delete failed');
            console.log(data.responseText);
          });
        }
      );
    }

  };

  self.update = function() {

  };

  self.cancel_new_comment = function() {
    console.log('canceling comment...');
    self.thread_comments.shift();
  };

  self.exists = function(obj) {
    return (typeof obj !== 'undefined');
  };

  self.vote_up = function(comment) {
    let id = self.id();
    let current_vote_count = self.vote_count();
    var type = 'up';
    if (self.voted() == 'up') {
      // neutralize vote
      self.vote_count(current_vote_count - 1);
      type = 'neutral';
    } else if (self.voted() == 'down') {
      // reverse vote
      self.vote_count(current_vote_count + 2);
    } else {
      self.vote_count(current_vote_count + 1);
    }
    self.voted(type);
    $.getJSON('/threads/' + self.id() + '/vote/' + type, {});
  };

  self.confirm_subscription = function($data, event){
    var $link = $(event.target);
    var $url = $link.data('href');

    const $modal = Modal.for('confirmation', {
      title: I18n.t('conversation.subscribe.confirm_title'),
      body: I18n.t('conversation.subscribe.confirm_body'),
      cancelBtnText: I18n.t('conversation.subscribe.confirm_cancel_button'),
      okBtnText: I18n.t('conversation.subscribe.confirm_ok_button'),
      layoutType: 'icon',
      iconClass: 'email-circle'
    });

    $modal.find('.js_cancel').on('click', function() {
      $modal.modal('hide');
    });

    $modal.find('.js_ok').on('click', function() {
      $modal.modal('hide');

      var request = new Kadenze.AjaxRequest({
        url: $url
      });

      request.done(function(data) {
        self.subscribed('true');

        new Kadenze.Notice.success({
          message: 'Subscribed for email updates'
        });
      });

      request.fail(function(data) {
        new Kadenze.Notice.error({
          message: Kadenze.I18n.t('notice.unexpected_error')
        });

        console.log('ERROR TO SUBSCRIBE USER.');
        console.log(data);
      });
    });
  };

  self.cancel_subscription = function($data, event){
    var $link = $(event.target);
    var $url = $link.data('href');

    const $modal = Modal.for('confirmation', {
      title: I18n.t('conversation.unsubscribe.confirm_title'),
      body: I18n.t('conversation.unsubscribe.confirm_body'),
      cancelBtnText: I18n.t('conversation.unsubscribe.confirm_cancel_button'),
      okBtnText: I18n.t('conversation.unsubscribe.confirm_ok_button'),
      layoutType: 'icon',
      iconClass: 'email-circle'
    });

    $modal.find('.js_cancel').on('click', function() {
      $modal.modal('hide');
    });

    $modal.find('.js_ok').on('click', function() {
      $modal.modal('hide');

      var request = new Kadenze.AjaxRequest({
        url: $url
      });

      request.done(function(data) {
        self.subscribed('');

        new Kadenze.Notice.success({
          message: 'Unsubscribed from email updates'
        });
      });

      request.fail(function(data) {
        new Kadenze.Notice.error({
          message: Kadenze.I18n.t('notice.unexpected_error')
        });

        console.log('ERROR TO SUBSCRIBE USER.');
        console.log(data);
      });

    });
  };

  self.removeComment = function(id, list) {
    var result,
      commentList = list || self.thread_comments;

    commentList.remove(function(comment) {
      if (comment.id() === id) {
        return true;
      } else if(comment.thread_comments().length) {
        return self.removeComment(id, comment.thread_comments);
      }
    });
  };

  self.userInfoTooltipParams = function (user) {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        username: user.slug(),
        email: null,
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'top',
      showDelay: .7
    };
  };

  self.bindData = function(data) {
    ko.mapping.fromJSON(data, self.mappingOptions, self);
  };

  const __construct = function(that) {
    console.log('constructor called for CommonForumThreadShowThreadVM');
    that.bindData(data);
    self.selected_filter(0);
  }(this);
}
